import React, {ComponentType, useState, useEffect} from "react";
import EventBlockout from "./index";
import {IProps, IContainerProps, IServices, IHandlers, IBaseProps} from './types';
import generalService from "external-services/general-settings-service/generalSettings.service";

/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";

const NS = 'EventBlockoutContainer';

const propsKeys: string[] = keys<IProps>();
const basePropsKeys: string[] = keys<IBaseProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();


const ThemeWrap = function (all: IContainerProps & IServices) {

  /**
   * Sorts 'all' into IServices, IProps and IContainerProps
   */
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const containerProps: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;
  /**
   * Passes all base props from container to component
   */
  // @ts-ignore
  basePropsKeys.forEach(key => props[key] = containerProps[key]);

  const [isLoading, setLoading] = useState<boolean>(true);
  const [staffRequiredCreateBlockout, setStaffRequiredCreateBlockout] = useState<boolean>(false);
  const [staffRequiredCreateEvent, setStaffRequiredCreateEvent] = useState<boolean>(false);
  const [staffRequiredEditBlockout, setStaffRequiredEditBlockout] = useState<boolean>(false);
  const [staffRequiredEditEvent, setStaffRequiredEditEvent] = useState<boolean>(false);

  props.isLoading = isLoading;

  props._staffRequiredCreateBlockout = staffRequiredCreateBlockout;
  props._staffRequiredCreateEvent = staffRequiredCreateEvent;
  props._staffRequiredEditBlockout = staffRequiredEditBlockout;
  props._staffRequiredEditEvent = staffRequiredEditEvent;

  useEffect(() => {

    generalService.get().then((settings) => {

      if (settings.staffRequiredCreateBlockout != undefined) {
        setStaffRequiredCreateBlockout(settings.staffRequiredCreateBlockout);
      }

      if (settings.staffRequiredCreateEvent != undefined) {
        setStaffRequiredCreateEvent(settings.staffRequiredCreateEvent);
      }

      if (settings.staffRequiredEditBlockout != undefined) {
        setStaffRequiredEditBlockout(settings.staffRequiredEditBlockout);
      }

      if (settings.staffRequiredEditEvent != undefined) {
        setStaffRequiredEditEvent(settings.staffRequiredEditEvent);
      }

      setLoading(false);
    })
  }, []);

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
    handleChange: (staffRequiredCreateBlockout, staffRequiredCreateEvent, staffRequiredEditBlockout, staffRequiredEditEvent) => {

      const eventBlockoutSettings = {
        staffRequiredCreateBlockout, staffRequiredCreateEvent, staffRequiredEditBlockout, staffRequiredEditEvent
      };

      containerProps.handleChange(eventBlockoutSettings);
    }
  }

  return ReactUtilsService.containerWrap(
    <EventBlockout {...props} {...handlers} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2AEventBlockout: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
